module.exports = __webpack_public_path__ + "statics/img/9.f2853dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/9.jpg
// module id = +MbP
// module chunks = 1